export const jigsawMobileAccent = "#3BA666";

export const promoNavy = "#0f172a";
export const promoSubtitle = "#64748b";
export const promoPillText = "#334155";

export const phoneShellSx = {
    width: "100%",
    maxWidth: "100%",
    minHeight: "100dvh",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 38%, #eef2f7 100%)",
    color: promoNavy,
    pt: "max(env(safe-area-inset-top, 0px), 44px)",
    pb: "env(safe-area-inset-bottom, 0px)",
};

export const promoHeaderSx = {
    flexShrink: 0,
    px: 2,
    pt: 1.5,
    pb: 1.5,
    textAlign: "center",
};

export const promoSystemFont = "-apple-system, BlinkMacSystemFont, sans-serif";

/** Headline + subtitle stack above the board (App Store screenshots). */
export const promoHeadlineStackSx = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.75,
    maxWidth: 340,
    mx: "auto",
};

export const promoHeadlineSx = {
    fontFamily: promoSystemFont,
    fontWeight: 700,
    fontSize: { xs: "2rem", sm: "2.25rem" },
    lineHeight: 1.25,
    letterSpacing: "-0.01em",
    color: promoNavy,
    m: 0,
};

export const promoHeadlineSubtitleSx = {
    fontFamily: promoSystemFont,
    fontWeight: 400,
    fontSize: { xs: "1rem", sm: "1.08rem" },
    lineHeight: 1.5,
    letterSpacing: "0.005em",
    color: promoSubtitle,
    m: 0,
};

/** @deprecated Legacy single-line all-caps title — prefer promoHeadlineSx. */
export const promoTitleSx = {
    ...promoHeadlineSx,
    fontWeight: 800,
    fontSize: { xs: "1.85rem", sm: "2rem" },
    letterSpacing: "0.03em",
    textTransform: "uppercase",
};

export const promoSubtitleSx = {
    fontSize: { xs: "1.25rem", sm: "1.35rem" },
    fontWeight: 600,
    color: promoSubtitle,
    letterSpacing: "0.01em",
};

export const puzzleTitleBarSx = {
    flexShrink: 0,
    px: 2,
    pt: 0.75,
    pb: 0.5,
    textAlign: "center",
};

export const featurePillsRowSx = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: 1,
    mt: 1.75,
};

export const featurePillSx = {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5,
    px: 1.35,
    py: 0.55,
    borderRadius: 999,
    bgcolor: "rgba(255,255,255,0.92)",
    border: "1px solid rgba(148,163,184,0.32)",
    boxShadow: "0 1px 4px rgba(15,23,42,0.06)",
    fontSize: "0.72rem",
    fontWeight: 600,
    fontFamily: promoSystemFont,
    color: promoPillText,
    whiteSpace: "nowrap",
};

export const boardRegionSx = {
    flexShrink: 0,
    width: "100%",
    boxSizing: "border-box",
};

/** Full-bleed board — no side margins. */
export const boardFrameSx = {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    borderRadius: 0,
    boxShadow: "0 8px 32px rgba(15, 23, 42, 0.12)",
};

export const trayRegionSx = {
    flexShrink: 0,
    overflow: "hidden",
    pt: 0,
    pb: 1.75,
    px: 1,
    background: "linear-gradient(180deg, rgba(248,250,252,0.98) 0%, #dbe4ee 55%, #cbd5e1 100%)",
    borderTop: "1px solid rgba(148,163,184,0.28)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.75)",
};

export const trayInnerSx = {
    borderRadius: 2,
    bgcolor: "rgba(255,255,255,0.45)",
    border: "1px solid rgba(255,255,255,0.65)",
    boxShadow: "inset 0 1px 2px rgba(15,23,42,0.04)",
};
